module.exports = __webpack_public_path__ + "static/media/ArnoPro-Regular.73cb8f81.svg";